// Module
var code = "<i v-if=\"name\" class=\"material-icons\" :aria-hidden=\"isHidden\" :aria-label=\"ariaLabel\">{{name}}</i> ";
// Exports
export default code;